var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPressNasdaq = function SvgPressNasdaq(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 458.135,
    height: 130.209,
    viewBox: "0 0 458.135 130.209",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NASDAQ_Logo",
    transform: "translate(0.012 -0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M232.475,77.46c-15.742,0-25.524-9.119-25.524-23.817,0-15.254,9.027-24.745,23.561-24.745h1.219a60.26,60.26,0,0,1,7.763.488V10.973h10.267V75.8a125.2,125.2,0,0,1-17.286,1.66m-.092-40.478c-9.946,0-14.782,5.368-14.782,16.405,0,9.91,5.835,16.069,15.21,16.069,1.8,0,3.866-.119,6.68-.36V37.642a44.673,44.673,0,0,0-7.108-.66M91.843,75.973l-27.734-48.4-.009,48.4H54.434V14.7H67.966L95.7,62.67,95.688,14.7h9.794v61.27Zm88.341.943a80.04,80.04,0,0,1-15.335-1.639l-.628-.119V66.6l.916.2c5.113,1.092,9.526,2.022,13.943,2.022,3.566,0,11.873-.559,11.873-5.809,0-4.4-5.74-5.508-10.35-6.391l-.291-.059c-.863-.161-1.674-.324-2.359-.5-6.763-1.755-13.978-4.393-13.978-13.455,0-8.839,7-13.9,19.2-13.9a84.632,84.632,0,0,1,13.523,1.136l1.66.244v8.307l-.883-.161a72.244,72.244,0,0,0-12.756-1.442c-4.845,0-10.594.907-10.594,5.217,0,3.578,4.705,4.6,10.154,5.788,7.62,1.648,17.066,3.718,17.066,14.115,0,9.538-7.7,15.011-21.155,15.011m98.4,0c-10.627,0-20.468-1.874-20.468-15.442,0-14.767,15.219-14.767,24.317-14.767.9,0,5.181.2,6.493.256-.012-8.283-.116-10.258-12.129-10.258a87,87,0,0,0-14.719,1.779l-.892.161V30.466l.6-.128A79.187,79.187,0,0,1,277.739,28.7c11.641,0,21.5,1.172,21.5,15.614v31.5l-.708.08a170.988,170.988,0,0,1-19.948,1.023m3.59-22.9c-8.774,0-14.21,1.291-14.21,7.715,0,7.435,6.936,8.051,13.443,8.051,2.427,0,6.8-.312,8.131-.407v-15.1c-1.88-.08-6.772-.256-7.364-.256m-147.651,22.9c-10.641,0-20.48-1.874-20.48-15.442,0-14.767,15.219-14.767,24.314-14.767.907,0,5.193.2,6.507.256-.012-8.283-.128-10.258-12.14-10.258A87,87,0,0,0,118,38.484l-.892.161V30.466l.616-.128A78.963,78.963,0,0,1,133.668,28.7c11.638,0,21.5,1.172,21.5,15.614v31.5l-.711.08a170.89,170.89,0,0,1-19.936,1.023m3.578-22.9c-8.771,0-14.2,1.291-14.2,7.715,0,7.435,6.924,8.051,13.431,8.051,2.439,0,6.808-.312,8.143-.407v-15.1c-1.895-.08-6.784-.256-7.376-.256",
    transform: "translate(107.484 21.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(415.173 50.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M33.022,68.91V48.81a49.78,49.78,0,0,1-7.852.559,32.73,32.73,0,0,1-12.084-2.358C5.255,43.754.586,35.486.586,24.877c0-5.294,1.291-14.975,9.922-20.191C14.841,2.1,19.954.992,27.645.992c2.751,0,6.469.208,10.059.416l5.832.3v62.54ZM26.877,9.079c-10.433,0-15.721,5.321-15.721,15.8,0,13.491,7.887,16.325,14.52,16.325a50.6,50.6,0,0,0,7.447-.512V9.37c-3.147-.208-4.6-.291-6.249-.291Z",
    transform: "translate(-0.586 -0.992)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665",
    transform: "translate(76.632 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M40.177.016,6.219,93.315A6.513,6.513,0,0,1,.758,97.559V97.6h35.9a6.494,6.494,0,0,0,6.112-4.286L76.739.016Z",
    transform: "translate(-0.758 -0.016)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M33.378,73.588a6.147,6.147,0,0,0,5.02-2.6,6.608,6.608,0,0,0,.812-1.511L51.666,35.236l-7.287-20a6.156,6.156,0,0,0-10.7-1.184,6.927,6.927,0,0,0-.812,1.511L20.414,49.794,27.733,69.87a6.148,6.148,0,0,0,5.645,3.718",
    transform: "translate(40.324 22.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(-0.012 32.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M77.364.984H41.071a6.508,6.508,0,0,0-6.124,4.289L.988,98.572H37.549l33.962-93.3A6.5,6.5,0,0,1,77.364,1Z",
    transform: "translate(-0.988 -0.984)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPressNasdaq);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/press-nasdaq.6dddc2a757b661f3de9308a168c6fb23.svg";